import React, { useEffect, useState } from "react";
import CrudPage, { ActiveBadge } from "@/components/CrudPage";
import api from "@/lib/api";

export default function Machines() {
  const [meta, setMeta] = useState({ departments: [] });
  useEffect(() => { api.get("/meta/options").then((r) => setMeta(r.data)).catch(() => {}); }, []);
  const deptOpts = meta.departments.map((d) => ({ value: d.code, label: d.name }));

  return (
    <CrudPage
      title="Makineler"
      subtitle="Makine tanımlama, durum ve kapasite bilgileri"
      endpoint="machines"
      testidPrefix="machines"
      defaultForm={{ active: true, status: "active", operators: 1, shift: "1. Vardiya" }}
      columns={[
        { key: "code", label: "Kod" },
        { key: "name", label: "Makine Adı" },
        { key: "department_code", label: "Bölüm", render: (m) => meta.departments.find((d) => d.code === m.department_code)?.name || m.department_code },
        { key: "machine_type", label: "Tip" },
        { key: "brand", label: "Marka/Model", render: (m) => [m.brand, m.model].filter(Boolean).join(" ") || "-" },
        { key: "shift", label: "Vardiya" },
        { key: "active", label: "Durum", render: (m) => <ActiveBadge value={m.active} /> },
      ]}
      fields={[
        { name: "code", label: "Makine Kodu", required: true, placeholder: "Örn: CNC-01" },
        { name: "name", label: "Makine Adı", required: true },
        { name: "department_code", label: "Bölüm", type: "select", options: deptOpts, required: true },
        { name: "machine_type", label: "Makine Tipi", placeholder: "CNC Torna, Enjeksiyon..." },
        { name: "brand", label: "Marka" },
        { name: "model", label: "Model" },
        { name: "shift", label: "Vardiya" },
        { name: "operators", label: "Operatör Sayısı", type: "number" },
        { name: "active", label: "Aktif", type: "checkbox" },
      ]}
    />
  );
}
